export const messages = {
  en: {
    payFeeConfigDiscountManage: {
      title: 'Fee Discount',
      discountId: 'Discount ID',
      feeName: 'Fee Item',
      discountName: 'Discount Name',
      rule: 'Rule',
      discountType: 'Discount Type',
      discount: 'Discount',
      penalty: 'Penalty',
      paymentPeriod: 'Payment Period',
      discountEndTime: 'Discount End Time',
      operation: 'Operation',
      paymentPeriodTip: 'Payment Period: This constrains the payment time, which is the time when the cashier operates the payment.',
      discountEndTimeTip: 'Discount End Time: This indicates the maximum payment time.',
      currentYearTip1: 'If the current year fee cannot enjoy the discount, select "No Arrears Rule" in the discount settings and set the arrears duration to 0.',
      currentYearTip2: 'This way, all overdue fees will not enjoy the discount, and the current year fee is considered overdue so it will not enjoy the discount.',
      fetchError: 'Failed to fetch discount data'
    },
    addPayFeeConfigDiscount: {
      addTitle: 'Add Discount',
      discountType: 'Discount Type',
      requiredPlaceholder: 'Required',
      selectDiscountType: 'Please select discount type',
      discount: 'Discount',
      penalty: 'Penalty',
      discountName: 'Discount Name',
      selectDiscountName: 'Please select discount name',
      paymentPeriod: 'Payment Period',
      startTimePlaceholder: 'Required, payment start time',
      endTimePlaceholder: 'Required, payment end time',
      paymentPeriodTip: 'Payment can only enjoy this discount during this period',
      discountEndTime: 'Discount End Time',
      discountEndTimePlaceholder: 'Optional, discount end time',
      discountEndTimeTip: 'Maximum payment time, e.g., for 2024 fee discount, fill in 2025-01-01',
      discountTypeRequired: 'Discount type is required',
      discountNameRequired: 'Discount name is required',
      startTimeRequired: 'Payment start time is required',
      endTimeRequired: 'Payment end time is required',
      fetchDiscountsError: 'Failed to fetch discounts',
      saveSuccess: 'Discount added successfully',
      saveError: 'Failed to add discount'
    },
    deletePayFeeConfigDiscount: {
      title: 'Confirm Operation',
      confirmText: 'Are you sure to delete this fee discount?',
      cancel: 'Cancel',
      deleteSuccess: 'Discount deleted successfully',
      deleteError: 'Failed to delete discount'
    },
  },
  zh: {
    payFeeConfigDiscountManage: {
      title: '费用折扣',
      discountId: '费用折扣ID',
      feeName: '费用项名称',
      discountName: '折扣名称',
      rule: '规则',
      discountType: '折扣类型',
      discount: '优惠',
      penalty: '违约',
      paymentPeriod: '缴费时间段',
      discountEndTime: '折扣终止时间',
      operation: '操作',
      paymentPeriodTip: '缴费时间段：这个约束缴费的时间，也就是前台收银员操作缴费的时间',
      discountEndTimeTip: '折扣终止时间：这个表示最大缴费到什么时候',
      currentYearTip1: '如果本年度费用不能享受优惠 那么在折扣设置中规则选择打折无欠费规则，并且欠费时长为0',
      currentYearTip2: '这样所有欠费的费用则不享受优惠，本年度的费用属于欠费所以不享受优惠',
      fetchError: '获取折扣数据失败'
    },
    addPayFeeConfigDiscount: {
      addTitle: '添加折扣',
      discountType: '折扣类型',
      requiredPlaceholder: '必填',
      selectDiscountType: '请选择折扣类型',
      discount: '优惠',
      penalty: '违约',
      discountName: '折扣名称',
      selectDiscountName: '请选择折扣名称',
      paymentPeriod: '缴费时间段',
      startTimePlaceholder: '必填，请填写缴费起始时间',
      endTimePlaceholder: '必填，请填写缴费结束时间',
      paymentPeriodTip: '这段时间内缴费才能享受该优惠',
      discountEndTime: '折扣终止时间',
      discountEndTimePlaceholder: '可选，填写折扣终止时间',
      discountEndTimeTip: '最大缴费到什么时候，比如想2024年费用优惠，那么就填写2025-01-01',
      discountTypeRequired: '折扣类型不能为空',
      discountNameRequired: '折扣名称不能为空',
      startTimeRequired: '有效期起始时间不能为空',
      endTimeRequired: '有效期终止时间不能为空',
      fetchDiscountsError: '获取折扣列表失败',
      saveSuccess: '添加成功',
      saveError: '添加失败'
    },
    deletePayFeeConfigDiscount: {
      title: '确认操作',
      confirmText: '确定删除费用折扣吗？',
      cancel: '点错了',
      deleteSuccess: '删除成功',
      deleteError: '删除失败'
}
  },
  'zh-TW': {
    payFeeConfigDiscountManage: {
      title: '費用折扣',
      discountId: '費用折扣ID',
      feeName: '費用項名稱',
      discountName: '折扣名稱',
      rule: '規則',
      discountType: '折扣類型',
      discount: '優惠',
      penalty: '違約',
      paymentPeriod: '繳費時間段',
      discountEndTime: '折扣終止時間',
      operation: '操作',
      paymentPeriodTip: '繳費時間段：這個約束繳費的時間，也就是前台收銀員操作繳費的時間',
      discountEndTimeTip: '折扣終止時間：這個表示最大繳費到什麼時候',
      currentYearTip1: '如果本年度費用不能享受優惠 那麼在折扣設置中規則選擇打折無欠費規則，並且欠費時長為0',
      currentYearTip2: '這樣所有欠費的費用則不享受優惠，本年度的費用屬於欠費所以不享受優惠',
      fetchError: '獲取折扣數據失敗'
    },
    addPayFeeConfigDiscount: {
      addTitle: '添加折扣',
      discountType: '折扣類型',
      requiredPlaceholder: '必填',
      selectDiscountType: '請選擇折扣類型',
      discount: '優惠',
      penalty: '違約',
      discountName: '折扣名稱',
      selectDiscountName: '請選擇折扣名稱',
      paymentPeriod: '繳費時間段',
      startTimePlaceholder: '必填，請填寫繳費起始時間',
      endTimePlaceholder: '必填，請填寫繳費結束時間',
      paymentPeriodTip: '這段時間內繳費才能享受該優惠',
      discountEndTime: '折扣終止時間',
      discountEndTimePlaceholder: '可選，填寫折扣終止時間',
      discountEndTimeTip: '最大繳費到什麼時候，比如想2024年費用優惠，那麼就填寫2025-01-01',
      discountTypeRequired: '折扣類型不能為空',
      discountNameRequired: '折扣名稱不能為空',
      startTimeRequired: '有效期起始時間不能為空',
      endTimeRequired: '有效期終止時間不能為空',
      fetchDiscountsError: '獲取折扣列表失敗',
      saveSuccess: '添加成功',
      saveError: '添加失敗'
    },
    deletePayFeeConfigDiscount: {
      title: '確認操作',
      confirmText: '確定刪除費用折扣嗎？',
      cancel: '點錯了',
      deleteSuccess: '刪除成功',
      deleteError: '刪除失敗'
    }
  }
}